import { GridColDef } from '@mui/x-data-grid';
import { CustomPagination, NoRowsOverlay } from '../../../../components/Layout';
import { dataGridDefaults } from '../../../../utils/constant';
import { StyledDataGrid } from './sx';

interface TableProps {
  rows: any[];
  columns: GridColDef[];
  page: number;
  onPageChange: (page: number) => void;
  rowCount: number;
  customNoRowOverlay?: React.ComponentType<any>;
  respectHeaderLineBreaks?: boolean;
  [key: string]: any;
}

const Table = (props: TableProps) => {
  const { rows, columns, page, onPageChange, rowCount, customNoRowOverlay, ...rest } = props;

  return (
    <StyledDataGrid
      {...dataGridDefaults}
      respectHeaderLineBreaks={props.respectHeaderLineBreaks}
      rows={rows}
      rowCount={rowCount}
      columns={columns}
      page={page}
      onPageChange={onPageChange}
      components={{
        NoRowsOverlay: customNoRowOverlay ? customNoRowOverlay : NoRowsOverlay,
        Footer: CustomPagination,
      }}
      componentsProps={{
        footer: { totalRecords: rowCount },
      }}
      {...rest}
    />
  );
};

export default Table;
